import _implicitStylesheets from "./tooltip.css";
import _implicitScopedStylesheets from "./tooltip.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import _c360ButtonIcon from "c360/buttonIcon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "tooltip-container": true
};
const stc1 = {
  key: 1
};
const stc2 = [];
const stc3 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_horizontal": true,
    "slds-grid_align-spread": true
  },
  key: 3
};
const stc4 = {
  "slds-popover__body": true
};
const stc5 = {
  key: 5
};
const stc6 = {
  attrs: {
    "name": "bubbleTop"
  },
  key: 6
};
const stc7 = {
  attrs: {
    "name": "bubbleBottom"
  },
  key: 8
};
const stc8 = {
  "close-icon": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {s: api_slot, gid: api_scoped_id, ncls: api_normalize_class_name, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "tabindex": "0",
      "aria-label": $cmp.content,
      "role": "tooltip"
    },
    key: 0
  }, [api_slot("", stc1, stc2, $slotset), api_element("section", {
    className: api_normalize_class_name($cmp.cssClassName),
    attrs: {
      "aria-label": $cmp.tooltipTitle,
      "aria-describedby": api_scoped_id("popover-body-id"),
      "role": "dialog"
    },
    key: 2
  }, [api_element("div", stc3, [api_element("div", {
    classMap: stc4,
    attrs: {
      "id": api_scoped_id("popover-body-id")
    },
    key: 4
  }, [api_element("p", stc5, [api_slot("bubbleTop", stc6, stc2, $slotset), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.content,
      "target": "_blank"
    },
    key: 7
  }), api_slot("bubbleBottom", stc7, stc2, $slotset)])]), api_custom_element("c360-button-icon", _c360ButtonIcon, {
    classMap: stc8,
    props: {
      "iconButtonName": "utility:close",
      "iconButtonVariant": "container",
      "iconDescription": $cmp.sharedLabels.close
    },
    key: 9,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleCloseClick))
    }
  })])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "bubbleBottom", "bubbleTop"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4od5r5khb58";
tmpl.legacyStylesheetToken = "pricing-tooltip_tooltip";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
